import React, { useContext as useContextCore } from 'react'
import type { UseListResult, useListWithSelection } from '@ztechapps/common.hook'
import { useRole } from '@ztechapps/common.hook'
import { invoicePermissions } from '@ztechapps/totalmilk-payme.common'
import { useInvoiceList } from '../hooks/useInvoiceList'
import type { Invoice } from '@ztechapps/totalmilk-payme.contract'
import { useInvoiceFilters } from '../hooks/useInvoiceFilters'

export type ProviderProps = {
  children: React.ReactNode
}

export type ContextType = {
  canEdit: boolean
  listWithSelection: ReturnType<typeof useListWithSelection<Invoice>>
  invoiceList: UseListResult<Invoice>
  totalAmount: number
  totalInvoices: number
  invoiceFilters: ReturnType<typeof useInvoiceFilters>
} & Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const InvoiceListProvider = ({ children, ...props }: ProviderProps) => {
  const { hasRole: canEdit } = useRole({ roleName: invoicePermissions.canEdit.value })

  const invoiceFilters = useInvoiceFilters()
  const listResult = useInvoiceList(invoiceFilters)

  return <CoreProvider value={{ ...props, canEdit, ...listResult, invoiceFilters }}>{children}</CoreProvider>
}

export const useInvoiceListContext = () => useContextCore(context)
